import { render, staticRenderFns } from "./RespostaDetalhes.vue?vue&type=template&id=6c3f8e99"
import script from "./RespostaDetalhes.vue?vue&type=script&lang=js"
export * from "./RespostaDetalhes.vue?vue&type=script&lang=js"
import style0 from "./RespostaDetalhes.vue?vue&type=style&index=0&id=6c3f8e99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports